import { render, staticRenderFns } from "./FacetInjections.vue?vue&type=template&id=4692a4cc&scoped=true"
import script from "./FacetInjections.vue?vue&type=script&lang=js"
export * from "./FacetInjections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4692a4cc",
  null
  
)

export default component.exports